(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "babel-runtime/helpers/extends", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("babel-runtime/helpers/extends"), require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.react);
    global.PdfIconSvg = mod.exports;
  }
})(this, function (exports, _extends2, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = PdfIcon;

  var _extends3 = _interopRequireDefault(_extends2);

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function PdfIcon(props) {
    return _react2.default.createElement(
      "svg",
      (0, _extends3.default)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 41,
        height: 49,
        viewBox: "0 0 41 49"
      }, props),
      _react2.default.createElement(
        "g",
        { fill: "none", fillRule: "evenodd" },
        _react2.default.createElement("path", {
          fill: "#757D99",
          d: "M4 0h36a1 1 0 0 1 1 1v44a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1z"
        }),
        _react2.default.createElement("rect", { width: 38, height: 46, y: 3, fill: "#DFE1E7", rx: 1 }),
        _react2.default.createElement("path", {
          fill: "#47506B",
          d: "M6.425 29.667h14.828a.795.795 0 0 1 0 1.59H6.425a.795.795 0 1 1 0-1.59zM6.425 34.8h8.828a.795.795 0 0 1 0 1.59H6.425a.795.795 0 1 1 0-1.59zM6.425 39.933h20.828a.795.795 0 0 1 0 1.59H6.425a.795.795 0 0 1 0-1.59z"
        }),
        _react2.default.createElement(
          "text",
          {
            fill: "#2D344B",
            fontFamily: "ProximaNova-Regular, Proxima Nova",
            fontSize: 12
          },
          _react2.default.createElement(
            "tspan",
            { x: 8, y: 16 },
            "PDF"
          )
        )
      )
    );
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/FileUploadStatusBox/icons/PdfIcon.svg.js
// module id = 2038
// module chunks = 1